import React from "react";
import WidgetBattery from "../WidgetBattery";

function THSensorBatteryWidget() {
  return (
    <div className="widget">
      <div className="dashboard-widget-title">
        <h1 className="dashboard-widget-title-name">온습도 센서</h1>
        <p className="dashboard-widget-title-place">장소</p>
      </div>
      <div className="dashboard-widget-footer">
        <WidgetBattery battery={20} />
        <span>20%</span>
      </div>
    </div>
  );
}

export default THSensorBatteryWidget;
